import { render } from "./LoanDetails.vue?vue&type=template&id=6737c45d&scoped=true"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"

import "./LoanDetails.vue?vue&type=style&index=0&id=6737c45d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6737c45d"]])

export default __exports__